// export default function Template({
//     data, // this prop will be injected by the GraphQL query below.
// }) {
//     const { markdownRemark, site, allMarkdownRemark } = data; // data.markdownRemark holds our post data
//     const { frontmatter } = markdownRemark;

//     return (
//         <div className="doc-container">
//             <div className="Navigation">
//                 <div><h2>Navigation</h2></div>
//             </div>
//             <div className="doc">
//                 <h1>{frontmatter.title}</h1>

//                 <h4>Applies to API version: {frontmatter.apiversion} </h4>
//                 <h4>Tags [{frontmatter.tags.join(', ')}]</h4>
//                 <h3>Resource Information</h3>
//                 <h4>Verb: {frontmatter.apiverb}</h4>
//                 <h4>API Endpoints</h4>
//                 Production: <code>{site.siteMetadata.productionServerURL}{frontmatter.apipath} </code><br />
//                 Test: <code>{site.siteMetadata.testServerURL}{frontmatter.apipath} </code><br /><br />
//             </div>
//         </div>
//     );
// }

import * as React from "react";

import DocPage from "../components/DocPage";

interface GraphQLWrapperProps {
	location: {
		pathname: string;
	};
	data: {
		allMarkdownRemark: {
			edges: Array<{
				node: {
					frontmatter: {
						path: string;
						title: string;
						category: string;
						order: number;
					};
				};
			}>;
		};
		markdownRemark: {
			frontmatter: {
				title: string;
				group: string;
				category: string;
			};
			htmlAst: any;
		};
		allConceptGroupsJson: {
			edges: Array<{
				node: {
					id: string;
					title: string;
				};
			}>;
		};
	};
}

const GraphQLWrapper = (props: GraphQLWrapperProps) => {
	const title = props.data.markdownRemark.frontmatter.title;
	const category = props.data.markdownRemark.frontmatter.category;
	const group = props.data.markdownRemark.frontmatter.group;
	const otherDocs = props.data.allMarkdownRemark.edges.map(e => e.node);
	const htmlAst = props.data.markdownRemark.htmlAst;
	const groups = props.data.allConceptGroupsJson.edges.map(e => e.node);

	return (
		<DocPage
			title={title}
			groups={groups}
			htmlAst={htmlAst}
			otherDocs={otherDocs}
			locationPath={props.location.pathname}
			selectedGroupId={group}
			category={category}
		/>
	);
};

export const pageQuery = graphql`
	query CoreConceptsByPath($relativePath: String!) {
		allMarkdownRemark(
			sort: { order: ASC, fields: [frontmatter___order] }
			filter: { frontmatter: { category: { eq: "core" } } }
		) {
			edges {
				node {
					frontmatter {
						path
						title
						category
						order
						group
					}
				}
			}
		}
		markdownRemark(frontmatter: { path: { eq: $relativePath } }) {
			htmlAst
			fileAbsolutePath
			frontmatter {
				date(formatString: "MMMM DD, YYYY")
				path
				title
				version
				tags
				category
				group
			}
		}
		allConceptGroupsJson {
			edges {
				node {
					id
					title
				}
			}
		}
	}
`;

export default GraphQLWrapper;



// WEBPACK FOOTER //
// ./src/templates/DocsCoreConceptsTemplate.tsx